import { get, find, flow, defaultTo, curry, toLower } from 'lodash/fp';

export const getChoice = curry((name, obj) => (
  flow(
    get('choices'),
    find(attr => toLower(get('optionName', attr)) === toLower(name)),
  )(obj)));

export const getChoiceValue = curry((name, obj) => (
  flow(
    getChoice(name),
    get('choiceValue'),
  )(obj)));

export const getChoiceValueOr = curry((defaultValue, name, obj) => (
  flow(
    getChoiceValue(name),
    defaultTo(defaultValue),
  )(obj)));

export const getChoicePrice = curry((name, obj) => (
  flow(
    getChoice(name),
    get('price'),
  )(obj)));

export const getChoicePriceOr = curry((defaultValue, name, obj) => (
  flow(
    getChoiceValue(name),
    defaultTo(defaultValue),
  )(obj)));
